import React, { useEffect, useState } from "react";
import { getNodeServiceBaseUrl } from "../../../config/apiBase";
import { EmptyState, ErrorState, Skeleton, PageHeader } from "../../../shared-ui/States";
import "../../../shared-ui/crane-tokens.css";

const token = () => localStorage.getItem("zTaskAuthToken") || "";

export default function AuditActivityPage() {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(true);
  const [err, setErr] = useState("");
  const [action, setAction] = useState("");
  const [entityType, setEntityType] = useState("");
  const [actorId, setActorId] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const load = async () => {
    setBusy(true);
    setErr("");
    try {
      const params = new URLSearchParams({ limit: "100" });
      if (action.trim()) params.set("action", action.trim());
      if (entityType.trim()) params.set("entityType", entityType.trim());
      if (actorId.trim()) params.set("actorId", actorId.trim());
      if (from) params.set("from", from);
      if (to) params.set("to", to);
      const res = await fetch(`${getNodeServiceBaseUrl()}/api/platform/audit-events?${params}`, {
        headers: { Authorization: `Bearer ${token()}`, "X-Client": "web" },
      });
      const body = await res.json();
      if (!res.ok) throw new Error(body.message || `HTTP ${res.status}`);
      setRows(body.data || []);
    } catch (e) {
      setErr(e.message);
      setRows([]);
    } finally {
      setBusy(false);
    }
  };

  useEffect(() => {
    void load();
  }, []);

  return (
    <div className="crane-page">
      <PageHeader
        crumbs={["Enterprise Platform", "Administration", "Audit"]}
        title="Audit & activity"
        description="Real platform.audit_events for this tenant. Empty when no events exist."
        actions={
          <button type="button" className="crane-btn" onClick={load} disabled={busy}>
            Refresh
          </button>
        }
      />

      <div className="crane-filters">
        <input className="crane-input" placeholder="Action / event type" value={action} onChange={(e) => setAction(e.target.value)} />
        <input className="crane-input" placeholder="Entity type" value={entityType} onChange={(e) => setEntityType(e.target.value)} />
        <input className="crane-input" placeholder="Actor id" value={actorId} onChange={(e) => setActorId(e.target.value)} />
        <input className="crane-input" type="date" value={from} onChange={(e) => setFrom(e.target.value)} aria-label="From date" />
        <input className="crane-input" type="date" value={to} onChange={(e) => setTo(e.target.value)} aria-label="To date" />
        <button type="button" className="crane-btn crane-btn--primary" onClick={load} disabled={busy}>
          Apply filters
        </button>
      </div>

      {busy && <Skeleton rows={6} />}
      {err && <ErrorState title="Could not load audit events" description={err} onRetry={load} />}
      {!busy && !err && rows.length === 0 && (
        <EmptyState title="No audit events" description="Audit events will appear here as the platform records activity." />
      )}
      {!busy && rows.length > 0 && (
        <div className="crane-card">
          <div className="crane-card__header">
            <h3 className="crane-card__title">Events</h3>
            <span className="crane-badge">{rows.length} shown</span>
          </div>
          <div style={{ overflowX: "auto" }}>
            <table className="crane-table">
              <thead>
                <tr>
                  <th>When</th>
                  <th>Action</th>
                  <th>Type</th>
                  <th>Entity</th>
                  <th>Actor</th>
                  <th>Result</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.id}>
                    <td style={{ whiteSpace: "nowrap" }}>
                      {r.occurred_at ? String(r.occurred_at).replace("T", " ").slice(0, 19) : "—"}
                    </td>
                    <td>{r.action || r.event_type}</td>
                    <td>{r.event_type}</td>
                    <td>
                      {r.entity_type || "—"} {r.entity_id ? `#${r.entity_id}` : ""}
                    </td>
                    <td>{r.actor_id || r.actor_type || "—"}</td>
                    <td>
                      <span className={`crane-badge ${String(r.result || "").toLowerCase().includes("fail") ? "crane-badge--err" : "crane-badge--ok"}`}>
                        {r.result || "—"}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
